import client from '../../base-api';

const serviceURL = '/dashboard/hr';

const dashboardHRService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },

    getPendingTimeManagement(filterData: any) {
        return client.get(`${serviceURL}/pending-time-management`, {params: filterData});
    },
}

export default dashboardHRService;